import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import styled from 'styled-components'
import queryString from 'query-string'
import PropTypes from 'prop-types'
import {push} from 'react-router-redux'
import R from 'ramda'
import moment from 'moment'
import {Form as UnstyledForm} from 'formsy-react-2'
import {
  Table, TableCell, TextIcon, TableHeader, TableLoading, TextInput,
  Title, Colors, Button, Pagination, ContextMenu, Icon, Modal,
  TableExpander
} from 'advenio-components'
import {parseFullName, parseToInt, userHasRole} from '../../utils/Utils'
import ServiceOccasionalActions from "../../Data/Redux/ServiceOccasionalRedux";
import Subcomponent from './Subcomponent'
import { BACK_OFFICE_CENTER_ROLES, BACK_OFFICE_ROLES, OFFICE_CENTER_ROLES } from '../../Constants'

const FormContainer = styled.div`
  display: block;
  margin: 0px 0px -60px 0px;
`
const Form = styled(UnstyledForm)`
  display: block;
  width: 100%;
  float: right;
`
const FiltersContainer = styled.div`
  display: flex;
  float: right;
`
const InputContainer = styled.div`
`
const Send = styled.div`
  display: block;
  align-content: center;
`
const TableContainer = styled.div`
  box-shadow: 1px 1px 16px 0px rgba(0, 0, 0, .3);
  border-radius: 4px;
`
const InfoCell = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  height: 26px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: center;
`
const StudentName = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: bold;
`
const PaginationContainer = styled.div`
  margin: 12px 0;
`
const Container = styled.div`
  padding: 54px;
`
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 16px;
`
const ValidatedText = styled(TextIcon)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: -8px;
`
const Actions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FFFFFF;
  height: 78px;
`
const Data = styled.div`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  background-color: #ffffff;
  text-overflow: ellipsis;
  white-space: normal;
  word-wrap: normal;
  overflow: hidden;
  padding: 5px;
  box-sizing: border-box;
  @media (max-width:767px) {
    height: 90px;
  }
`
class ServiceOccasional extends Component {
  state = {
    pageSelected: 1,
    queryParams: {},
    services: [],
    expanded: [],
  }

  componentWillMount = () => {
    const {location: {search}, user: {center_id}, getServiceOccasionals} = this.props
    const queryParams = queryString.parse(search)

    if (queryParams.page) {
      this.setState({pageSelected: parseInt(queryParams.page)})
    }
    this.setState({queryParams})
    getServiceOccasionals(center_id, queryParams)

  }

  onClickPage = (page) => {
    const {goTo, getServiceOccasionals, user: {center_id}} = this.props
    this.setState({pageSelected: page}, () => {
      const {queryParams} = this.state

      const queries = {...queryParams, page}
      getServiceOccasionals(center_id, queries)
      goTo(`?${queryString.stringify(queries)}`)
    })
  }

  onFilter = (query) => {
    const queries = R.clone(query)
    const {goTo, getServiceOccasionals, user: {center_id}} = this.props
    Object.keys(queries).map((value) => {
      if (!query[value]) {
        delete queries[value]
      }
    })
    this.setState({queryParams: queries, pageSelected: 1});
    goTo(`?${queryString.stringify(queries)}`)
    getServiceOccasionals(center_id, queries)
  }

  handleAddService = () => {
    return this.props.goTo(`/occasional/new`)
  }

  handleExport = () => {
    this.props.exportServiceOccasionals(this.props.user.center_id)
  }

  openRow = (index) => {
    const newState = { ...this.state }
    if (newState.expanded[index]) {
      newState.expanded[index] = false
    } else {
      newState.expanded[index] = true
    }
    this.setState(newState)
  }

  handleDeleteService = (id) => {
    this.props.deleteServiceOccasional(this.props.user.center_id, id)
  }

  render() {
    const {
      meta,
      services,
      loading,
      user,
    } = this.props
    const {
      pageSelected,
      queryParams,
      expanded
    } = this.state


    return (
      <Container>
        <HeaderContainer>
          <Title>Servicio Ocasional</Title>
          <FormContainer>
            <Form onSubmit={this.onFilter}>
              <FiltersContainer>
                <InputContainer>
                  <TextInput
                    name="name"
                    label="Nombre del Alumno"
                    value={queryParams.name || ''}
                  />
                </InputContainer>
                <Send>
                  <Button marginRight="70%" loading={loading} primary small type="submit">Filtrar</Button>
                </Send>
                <Send>
                  <Button loading={loading} success small onClick={() => this.handleAddService()} type="button">
                    <TextIcon iconType="plus" label="Servicio"/>
                  </Button>
                </Send>
                <Send>
                  <Button loading={loading} success small onClick={() => this.handleExport()} type="button">
                    Exportar
                  </Button>
                </Send>
              </FiltersContainer>
            </Form>
          </FormContainer>
        </HeaderContainer>
        <PaginationContainer>
          <Pagination
            totalElements={meta && meta.total}
            elementsPerPage={meta && meta.per_page}
            onPageClick={this.onClickPage}
            pageSelected={pageSelected}
          />
        </PaginationContainer>
        {loading ?
          <TableLoading
            roundedCorners
            columns={[
              {
                id: 1,
                header: 'Alumno',
                element: 'Text',
                center: true,
              },
              {
                id: 2,
                header: 'Programa',
                element: 'Text',
                center: true,
              },
              {
                id: 3,
                header: 'Servicio',
                element: 'Text',
                center: true,
              },
              /*{
                id: 4,
                header: 'Fechas de Inicio y Fin',
                element: 'Text',
                center: true,
              },*/
            /*  {
                id: 5,
                header: 'Centro',
                element: 'Text',
                center: true,
              },*/
            /* {
                id: 6,
                header: 'Monto Detallado',
                element: 'Text',
                center: true,
              },
              {
                id: 7,
                header: 'Monto Comprobado',
                element: 'Text',
                center: true,
              },*/
              {
                id: 8,
                header: 'Comprobante',
                element: 'Text',
                center: true,
              }
            ]}
            rows={8}
          /> :
          <TableContainer>
            <Table
              roundedCorners
              SubComponent={Subcomponent}
              data={services}
              expanded={expanded}
              columns={
                (() => {
                  let columns = [
                    {
                      expander: true,
                      Header: () => <TableHeader blue />,
                      Expander: ({ isExpanded, ...rest }) =>
                        (<Data>
                          <TableExpander
                            id={rest.index}
                            open={isExpanded}
                            openCard={() => this.openRow(rest.index)}
                          />
                        </Data>),
                    },
                    {
                      id: 1,
                      Header: () => <TableHeader title="Alumno" blue center/>,
                      accessor: ({fullName}) => ({fullName}),
                      Cell: ({value: {fullName}}) => (
                        <TableCell center>
                          <InfoCell>
                            <InfoRow>
                              <StudentName>
                                {fullName}
                              </StudentName>
                            </InfoRow>
                          </InfoCell>
                        </TableCell>
                      ),
                    },
                    {
                      id: 2,
                      Header: () => <TableHeader title="Programa" blue center/>,
                      accessor: ({program}) => program,
                      Cell: ({value: program}) =>
                        <TableCell center>{program}</TableCell>,
                    },
                    {
                      id: 3,
                      Header: () => <TableHeader title="Servicio" blue center/>,
                      accessor: ({service}) => service,
                      Cell: ({value: service}) =>
                        <TableCell center>{service}</TableCell>,
                    },
                    /*{
                      id: 4,
                      Header: () => <TableHeader title="Fechas de Inicio y Fin" blue center/>,
                      accessor: ({start_date, end_date}) => ({start_date, end_date}),
                      Cell: ({value: {start_date, end_date}}) => <TableCell center>
                        <InfoCell>
                          <InfoRow>
                            <ParentName>
                              {start_date}
                            </ParentName>
                          </InfoRow>
                          <InfoRow>
                              <ParentName>
                                {end_date}
                              </ParentName>
                          </InfoRow>
                        </InfoCell>
                      </TableCell>,
                    },*/
                    /*{
                        id: 5,
                        Header: () => <TableHeader title="Centro" blue center/>,
                        accessor: ({center}) => ({center}),
                        Cell: ({value: {center: {name}}}) => <TableCell center>  {name}</TableCell>,
                    },*/
                    /*{
                        id: 6,
                        Header: () => <TableHeader title="Monto Detallado" blue center/>,
                        accessor: ({amount_tuition_fee, amount_extra}) => ({amount_tuition_fee, amount_extra}),
                        Cell: ({value: {amount_tuition_fee, amount_extra}}) => <TableCell center> {(amount_tuition_fee)} </TableCell>,
                    },*/
                    {
                      id: 7,
                      Header: () => <TableHeader title="Monto Comprobado" blue center/>,
                      accessor: ({amount_total}) => ({amount_total}),
                      Cell: ({value: {amount_total}}) => <TableCell center>  {amount_total}</TableCell>,
                    },
                    /*{
                      id: 8,
                      Header: () => <TableHeader title="Comprobante" center blue/>,
                      accessor: ({receipt_full_path}) => ({receipt_full_path}),
                      Cell: ({value: {receipt_full_path}}) => <TableCell center><img alt="" style={{cursor: 'pointer'}}
                                                                                      onClick={() => window.open(receipt_full_path)}
                                                                                      src="/assets/visibility.svg"/></TableCell>,
                    },*/
                  ];
                  if (userHasRole(user,OFFICE_CENTER_ROLES)) {
                    columns.push({
                      id: 9,
                      Header: () => <TableHeader title="" blue center/>,
                      accessor: ({id}) => ({id}),
                      Cell: ({value: {id}}) => <TableCell center>
                        {userHasRole(user,BACK_OFFICE_CENTER_ROLES) ? <Button danger small onClick={() => this.handleDeleteService(id)} type="button">Eliminar</Button> : ''}
                      </TableCell>,
                    });
                  }
                  return columns;
                })()
              }
            />
          </TableContainer>
        }
      </Container>
    )
  }
}


ServiceOccasional.defaultProps = {
  loading: false,
  services: [],
  meta: {},
  location: {},
}

const mapStateToProps = state => ({
  /** Error and loading for modal options */
  loading: state.serviceOccasional.get.fetching,
  services: state.serviceOccasional.get.results.data,
  meta: state.serviceOccasional.get.results.meta,
  user: state.auth.user,
})

const mapDispatchToProps = dispatch => ({
  getServiceOccasionals: (centerId, query) => dispatch(ServiceOccasionalActions.getRequest({centerId, query}, true)),
  exportServiceOccasionals: (centerId) => dispatch(ServiceOccasionalActions.exportServiceOccasionalRequest({centerId}, true)),
  deleteServiceOccasional: (centerId, occasionalId) => dispatch(ServiceOccasionalActions.deleteServiceOccasionalRequest(centerId, occasionalId)),
  goTo: path => dispatch(push(path)),

})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServiceOccasional))



// WEBPACK FOOTER //
// ./src/Containers/ServiceOccasional/index.jsx